import SpriteSymbol from "../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "newsfeed-arrow",
  "use": "newsfeed-arrow-usage",
  "viewBox": "0 0 42 46",
  "content": "<symbol viewBox=\"0 0 42 46\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\" id=\"newsfeed-arrow\"><path d=\"M.38 22.62l31.482.38M24.276 44.957l15.172-22.336L24.276 1\" stroke=\"#36B0DB\" stroke-width=\"3\" /></symbol>"
});
var result = sprite.add(symbol);
export default "#" + symbol.id